import React from 'react';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { createProjectAsync } from '../../../redux/project/Actions';

import { withStyles } from '@material-ui/core/styles';
import {
    Button,
    Divider,
    Modal,
    Paper,
    Typography,
    Badge,
    FormControlLabel,
    Checkbox,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Box
} from '@material-ui/core';
import FolderIcon from '@material-ui/icons/Folder';

import TextField from '../../Common/UI/TextField';
import DialogButton from '../../Common/UI/Dialog/DialogButton';
import InfoIconTooltip from '../../Common/UI/InfoIconTooltip';

class NewProjectModal extends React.Component {
    constructor(props) {
        super(props);

        this.submitCreateProject = this.submitCreateProject.bind(this);

        this.state = {
            projectName: '',
            projectShared: false,
            error: false,
            errorMessage: ''
        };
    }

    submitCreateProject(e) {
        e.preventDefault();
        const { onClose, dispatchCreateProjectAsync, projects } = this.props;
        const { projectName, projectShared } = this.state;

        if (!projectName) {
            this.setState({ error: true });
            this.setState({ errorMessage: "Project name can't be empty" });
        } else if (
            projects.some(p => p.name.toLowerCase() === projectName.toLowerCase())
        ) {
            this.setState({ error: true });
            this.setState({ errorMessage: 'Project name already exists' });
        } else {
            this.setState({ error: false });
            dispatchCreateProjectAsync(
                projectName,
                projectShared ? 'organisation' : null
            );
            onClose();
        }
    }

    render() {
        const { classes, open, onClose } = this.props;
        const { projectName, projectShared } = this.state;

        return (
            <Dialog open={open} onClose={onClose} fullWidth>
                <DialogTitle disableTypography>
                    <FolderIcon />
                    <Typography variant="h4">New Project</Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <TextField
                        label="Project name"
                        fullWidth
                        variant="outlined"
                        value={projectName}
                        onChange={e =>
                            this.setState({ projectName: e.target.value })
                        }
                    />
                    <Box display="flex" alignItems="center">
                        <FormControlLabel
                            label="Share with organisation"
                            color="primary"
                            className={`${classes.grey} ${classes.label}`}
                            control={
                                <Checkbox
                                    checked={projectShared}
                                    onChange={(e, newValue) =>
                                        this.setState({ projectShared: newValue })
                                    }
                                />
                            }
                        />
                        <InfoIconTooltip
                            className={classes.infoIconTooltip}
                            title="If check box is selected, this project will be shared with all other members of your organisation."
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <DialogButton
                        variant="contained"
                        type="submit"
                        onClick={this.submitCreateProject}>
                        CREATE
                    </DialogButton>
                    <DialogButton variant="outlined" onClick={onClose}>
                        CANCEL
                    </DialogButton>
                </DialogActions>
            </Dialog>
        );
    }
}

const styles = theme => ({
    grey: {
        color: theme.palette.grey.variant4,
        margin: '0px !important'
    },
    label: {
        '& > span': {
            fontSize: `${theme.typography.body2.fontSize} !important`,
            padding: '0px'
        },
        '& > span:last-child': {
            marginLeft: '0.5rem'
        }
    },
    infoIconTooltip: { marginLeft: '0.37rem' }
});

const mapStateToProps = state => ({
    currentProject: state.project.currentProject,
    projects: state.project.projects
});

const mapDispatchToProps = dispatch => ({
    dispatchCreateProjectAsync: (name, visibility) =>
        dispatch(createProjectAsync(name, visibility))
});

export default compose(
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps)
)(NewProjectModal);
